import React, { Component } from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'

import MaterialTimePicker from 'material-ui/TimePicker'

export default class TimePicker extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    extraClass: PropTypes.string,
    label: PropTypes.string,
    labelClass: PropTypes.string,
    validationFuncs: PropTypes.array,
    value: PropTypes.object
  }

  static defaultProps = {
    extraClass: '',
    validationFuncs: []
  }

  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    const groupClass = classNames({
      'form-group': true,
      'has-danger': !this.state.isValid,
      [this.props.wrapperClass]: !!this.props.wrapperClass
    })

    const labelClassName = classNames({
      [this.props.labelClass]: !!this.props.labelClass
    })

    return (
      <fieldset className={groupClass}>
        {this.props.label && (
          <label className={labelClassName} htmlFor={this.props.id}>
            {this.props.label}
          </label>
        )}
        <div className={this.props.extraClass}>
          <MaterialTimePicker
            id={this.props.id}
            className="material-time-picker"
            format="24hr"
            value={this.props.value}
            onChange={(_, value) => {
              this.props.onChange(this.props.id, moment(value))
            }}
          />
        </div>
        {this.state.errorMessage && <small className="text-danger">{this.state.errorMessage}</small>}
      </fieldset>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/TimePicker.js